import React from 'react';

interface IProps {
  style?: any;
}

const FlipIcon:React.FC<IProps> = (props: IProps) => {
  return (
    <svg width="22" height="22" viewBox="0 0 17.8 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path 
        d="M9.45.467v1.4a.46.46 0 0 1-.45.466.46.46 0 0 1-.45-.466v-1.4A.46.46 0 0 1 9 0c.248 0 .45.21.45.467zM9 3.733a.46.46 0 0 0-.45.467v1.4a.46.46 0 0 0 .45.467.46.46 0 0 0 .45-.467V4.2A.46.46 0 0 0 9 3.733zm0 3.734a.46.46 0 0 0-.45.466v1.4A.46.46 0 0 0 9 9.8a.46.46 0 0 0 .45-.467v-1.4A.46.46 0 0 0 9 7.467zM9 11.2a.46.46 0 0 0-.45.467v1.4a.46.46 0 0 0 .45.466.46.46 0 0 0 .45-.466v-1.4A.46.46 0 0 0 9 11.2zm0 3.733a.46.46 0 0 0-.45.467v1.4a.46.46 0 0 0 .45.467.46.46 0 0 0 .45-.467v-1.4a.46.46 0 0 0-.45-.467zm0 3.734a.46.46 0 0 0-.45.466v1.4A.46.46 0 0 0 9 21a.46.46 0 0 0 .45-.467v-1.4a.46.46 0 0 0-.45-.466zM17.663 5.18l-5.4-1.4c-.136-.047-.27 0-.383.093a.494.494 0 0 0-.18.374V15.4c0 .21.135.397.338.443l5.4 1.4c.135.024.27 0 .382-.093a.493.493 0 0 0 .18-.373V5.623a.447.447 0 0 0-.337-.443zM6.12 3.85a.422.422 0 0 0-.27-.093c-.045 0-.067 0-.112.023l-5.4 1.4A.447.447 0 0 0 0 5.623v11.154c0 .14.068.28.18.373a.457.457 0 0 0 .383.093l5.4-1.4A.447.447 0 0 0 6.3 15.4V4.223c0-.14-.067-.28-.18-.373z" 
        fill={props.style?.fillColor ? props.style.fillColor : "#424C57"}
      />
    </svg>
  )
}

export default FlipIcon;